import { render, staticRenderFns } from "./ActivityRules.vue?vue&type=template&id=ef25193e&scoped=true"
import script from "./ActivityRules.vue?vue&type=script&lang=js"
export * from "./ActivityRules.vue?vue&type=script&lang=js"
import style0 from "./ActivityRules.vue?vue&type=style&index=0&id=ef25193e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef25193e",
  null
  
)

export default component.exports